import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import getBrowserFingerprint from 'get-browser-fingerprint';
import axios from "axios";
import { Base64 } from 'js-base64';

const UnsubscribePage = () => {
    const fingerprint = getBrowserFingerprint();
    const navigate = useNavigate();
    const { code } = useParams(); // Get token from URL path
    const { token } = useParams(); // Get token from URL path
    const [status, setStatus] = useState('idle'); // idle, loading, success, error
    const [message, setMessage] = useState('');

    const [msg , setMsg] = useState('');

    const handleUnsubscribecode = async () => {
  const res = await axios.get(
    `${process.env.REACT_APP_API_ENDPOINT}/agencyunsubscrible/${code}`
  );
  if(res.data === true){
    setMsg("You have successfully unsubscribed from email notifications.");
    }
    else{
    setMsg("You have already unsubscribed or your token has expired.");
    }
  return res;
};

  const handleUnsubscribetoken = async () => {
  const res = await axios.get(
    `${process.env.REACT_APP_API_ENDPOINT}/unsubscrible/${token}`
  );

  if(res.data === true){
    setMsg("You have successfully unsubscribed from email notifications.");
    }
    else{
    setMsg("You have already unsubscribed or your token has expired.");
    }

  return res;
};


useEffect(() => {
    if(code){
    handleUnsubscribecode()
    }
    else if(token){
    handleUnsubscribetoken()
    }
}, [code , token]);

    const restorePage = () => {
        if (localStorage.getItem('PID')) {
            localStorage.setItem('PID', Base64.encode(fingerprint + 'P2'));
            navigate('/');
            window.location.reload();
        } else {
            navigate('/');
        }
    };

    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'unsubscribe_page_view',
            'pagePath': '/unsubscribe' + window.location.pathname,
            'pageType': 'unsubscribe'
        });
    }, []);

    return (
        <section className="header3 theme-space px-lg-5 mb-5">
            <div className="container">
                <div className="row">
                    <div className="col-md-9 mx-auto text-center mb-4">
                        <h2 className="mb-3">{msg}</h2>
                       
                    </div>

                    <div className="col-md-6 mx-auto text-center">
                        <Link 
                            onClick={restorePage} 
                            to="/" 
                            className="back_home"
                            style={{ 
                                padding: '10px 30px', 
                                display: 'inline-block',
                                textDecoration: 'none'
                            }}
                        >
                            BACK TO HOME
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default UnsubscribePage;
